// GuidedTourContext.js
import { createContext, useCallback, useContext, useRef, useState } from "react";
import Joyride from "react-joyride";
// import API from "../../axios/API";
import { DataContext } from "../DataProviders/DataProvider";

export const GuidedTourContext = createContext();
export const useGuidedTour = () => useContext(GuidedTourContext);

export const GuidedTourProvider = ({ children }) => {
    const [isTourActive, setIsTourActive] = useState(false);

    const { userHasSeenTour } = useContext(DataContext);
    const [anchorElUser, setAnchorElUser] = useState(null);
    const profileRef = useRef()

    const steps = [
        {
            target: '[data-tour-id="Dashboard"]',
            content: (
                <div style={{ fontFamily: 'Roboto, sans-serif' }}>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                        <div style={{
                            background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
                            padding: '12px 16px',
                            marginBottom: '16px',
                            borderRadius: '8px',
                            boxShadow: '0 4px 12px rgba(25, 118, 210, 0.2)',
                            width: '80%',
                        }}>
                            <h3 style={{ margin: 0, color: '#ffffff', fontSize: '18px', fontWeight: '700', letterSpacing: '0.3px' }}>
                                🏠 Welcome to Your Dashboard!
                            </h3>
                        </div>
                    </div>
                    <p style={{ margin: '0 0 12px 0', color: '#546e7a', fontSize: '14px', lineHeight: '1.6' }}>
                        Your central hub for monitoring all activities. Get insights into your orders, email accounts, and billing at a glance.
                    </p>
                </div>
            ),
            placement: "right-start",
            disableBeacon: true
        },
        {
            target: '[data-tour-id="Orders"]',
            content: (
                <div style={{ fontFamily: 'Roboto, sans-serif' }}>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                        <div style={{
                            background: 'linear-gradient(135deg, #7b1fa2 0%, #6a1b9a 100%)',
                            padding: '12px 16px',
                            marginBottom: '16px',
                            borderRadius: '8px',
                            boxShadow: '0 4px 12px rgba(123, 31, 162, 0.2)',
                            width: '80%',
                        }}>
                            <h3 style={{ margin: 0, color: '#ffffff', fontSize: '18px', fontWeight: '700', letterSpacing: '0.3px' }}>
                                📦 Order Management
                            </h3>
                        </div>
                    </div>
                    <p style={{ margin: '0 0 12px 0', color: '#546e7a', fontSize: '14px', lineHeight: '1.6' }}>
                        Create, track, and manage all your orders efficiently. View order history, status updates, and detailed information in one place.
                    </p>
                </div>
            ),
            placement: "right-start"
        },
        {
            target: '[data-tour-id="Email-Accounts"]',
            content: (
                <div style={{ fontFamily: 'Roboto, sans-serif' }}>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                        <div style={{
                            background: 'linear-gradient(135deg, #0288d1 0%, #0277bd 100%)',
                            padding: '12px 16px',
                            marginBottom: '16px',
                            borderRadius: '8px',
                            boxShadow: '0 4px 12px rgba(2, 136, 209, 0.2)',
                            width: '80%',
                        }}>
                            <h3 style={{ margin: 0, color: '#ffffff', fontSize: '18px', fontWeight: '700', letterSpacing: '0.3px' }}>
                                ✉️ Email Configuration
                            </h3>
                        </div>
                    </div>
                    <p style={{ margin: '0 0 12px 0', color: '#546e7a', fontSize: '14px', lineHeight: '1.6' }}>
                        Connect and manage your email accounts seamlessly.
                    </p>
                </div>
            ),
            placement: "right-start"
        },
        {
            target: '[data-tour-id="Domain"]',
            content: (
                <div style={{ fontFamily: 'Roboto, sans-serif' }}>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>

                        <div style={{
                            background: 'linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%)',
                            padding: '12px 16px',
                            marginBottom: '16px',
                            borderRadius: '8px',
                            boxShadow: '0 4px 12px rgba(46, 125, 50, 0.2)',
                            width: '80%',
                        }}>
                            <h3 style={{ margin: 0, color: '#ffffff', fontSize: '18px', fontWeight: '700', letterSpacing: '0.3px' }}>
                                🌐 Domain Management
                            </h3>
                        </div>
                    </div>
                    <p style={{ margin: '0 0 12px 0', color: '#546e7a', fontSize: '14px', lineHeight: '1.6' }}>
                        Manage your domains effortlessly. Add new domains, configure DNS settings, and monitor domain health and performance.
                    </p>
                </div>
            ),
            placement: "right-start"
        },
        {
            target: '[data-tour-id="Help-&-Support"]',
            content: (
                <div style={{ fontFamily: 'Roboto, sans-serif' }}>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                        <div style={{
                            background: 'linear-gradient(135deg, #ed6c02 0%, #e65100 100%)',
                            padding: '12px 16px',
                            marginBottom: '16px',
                            borderRadius: '8px',
                            boxShadow: '0 4px 12px rgba(237, 108, 2, 0.2)',
                            width: '80%',
                        }}>
                            <h3 style={{ margin: 0, color: '#ffffff', fontSize: '18px', fontWeight: '700', letterSpacing: '0.3px' }}>
                                🆘 Help & Support
                            </h3>
                        </div>
                    </div>
                    <p style={{ margin: '0 0 12px 0', color: '#546e7a', fontSize: '14px', lineHeight: '1.6' }}>
                        Need assistance? Create support tickets, track your queries, and get help from our dedicated support team anytime.
                    </p>
                </div>
            ),
            placement: "right-start"
        },
        {
            target: '[data-tour-id="Billing"]',
            content: (
                <div style={{ fontFamily: 'Roboto, sans-serif' }}>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                        <div style={{
                            background: 'linear-gradient(135deg, #d32f2f 0%, #c62828 100%)',
                            padding: '12px 16px',
                            marginBottom: '16px',
                            borderRadius: '8px',
                            boxShadow: '0 4px 12px rgba(211, 47, 47, 0.2)',
                            width: '80%',
                        }}>
                            <h3 style={{ margin: 0, color: '#ffffff', fontSize: '18px', fontWeight: '700', letterSpacing: '0.3px' }}>
                                💳 Billing & Payments
                            </h3>
                        </div>
                    </div>
                    <p style={{ margin: '0 0 12px 0', color: '#546e7a', fontSize: '14px', lineHeight: '1.6' }}>
                        Manage your billing information, view invoices, track payments, and update payment methods securely in one convenient location.
                    </p>
                </div>
            ),
            placement: "right-start"
        },
        {
            target: '[data-tour-id="Profile-Setting"]',
            content: (
                <div style={{ fontFamily: 'Roboto, sans-serif' }}>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                        <div style={{
                            background: 'linear-gradient(135deg, #00897b 0%, #00695c 100%)',
                            padding: '12px 16px',
                            marginBottom: '16px',
                            borderRadius: '8px',
                            boxShadow: '0 4px 12px rgba(0, 137, 123, 0.2)',
                            width: '80%',
                        }}>
                            <h3 style={{ margin: 0, color: '#ffffff', fontSize: '18px', fontWeight: '700', letterSpacing: '0.3px' }}>
                                ⚙️ Profile & Settings
                            </h3>
                        </div>
                    </div>
                    <p style={{ margin: '0 0 12px 0', color: '#546e7a', fontSize: '14px', lineHeight: '1.6' }}>
                        Customize your experience! Update personal information, configure preferences, manage security settings, and personalize your account.
                    </p>
                </div>
            ),
            placement: "right-start"
        },
    ];

    const startTour = useCallback(() => {
        setIsTourActive(true);
    }, []);

    const handleJoyrideCallback = (data) => {
        const { status, index } = data;

        const finished = ["finished", "skipped"].includes(status);
        const currentStep = steps[index];

        if (isTourActive && currentStep?.target?.includes("Help") && profileRef.current) {
            setAnchorElUser(profileRef.current);
        }

        if (finished) {
            setIsTourActive(false);
            if (!userHasSeenTour) {
                // api call
                // API.post(`${import.meta.env.BACKEND_API}/tour-completed`,
                //     { customerId: Number(loginCustomerId) }
                // )
            }
        }
    };

    return (
        <GuidedTourContext.Provider value={{ startTour, setAnchorElUser, anchorElUser, profileRef }}>
            <Joyride
                steps={steps}
                continuous
                disableScrolling
                showSkipButton
                showProgress
                run={isTourActive}
                callback={handleJoyrideCallback}
                locale={{
                    back: "Back",
                    close: "Close",
                    last: "Finish",
                    next: "Next",
                    skip: "Skip"
                }}
                styles={{
                    options: {
                        zIndex: 10000,
                        primaryColor: '#1976d2', // MUI Primary Blue
                        backgroundColor: '#ffffff',
                        textColor: '#263238',
                        overlayColor: 'rgba(0, 0, 0, 0.6)',
                        arrowColor: '#ffffff',
                        spotlightPadding: 10,
                    },
                    tooltip: {
                        backgroundColor: '#ffffff',
                        borderRadius: '16px',
                        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15), 0 0 1px rgba(0, 0, 0, 0.1)',
                        padding: '0',
                        border: 'none',
                        width: '600px',
                        height: '240px',
                        overflow: 'hidden',
                    },
                    tooltipContent: {
                        padding: '20px 24px',
                    },
                    buttonNext: {
                        backgroundColor: '#1976d2', // MUI Primary Blue
                        borderRadius: '10px',
                        padding: '12px 28px',
                        fontSize: '14px',
                        fontWeight: '600',
                        border: 'none',
                        color: '#ffffff',
                        cursor: 'pointer',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
                        whiteSpace: 'nowrap',
                        minWidth: 'fit-content',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        outline: 'none',
                    },
                    buttonBack: {
                        color: '#1976d2', // MUI Primary Blue
                        fontSize: '14px',
                        fontWeight: '600',
                        border: '2px solid #1976d2',
                        backgroundColor: 'transparent',
                        cursor: 'pointer',
                        padding: '10px 24px',
                        borderRadius: '10px',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        whiteSpace: 'nowrap',
                        minWidth: 'fit-content',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        outline: 'none',
                    },
                    buttonSkip: {
                        color: '#78909c', // MUI Blue Grey
                        fontSize: '13px',
                        fontWeight: '600',
                        border: 'none',
                        backgroundColor: 'transparent',
                        cursor: 'pointer',
                        padding: '10px 20px',
                        borderRadius: '10px',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        whiteSpace: 'nowrap',
                        minWidth: 'fit-content',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        outline: 'none',
                    },
                    buttonClose: {
                        fontSize: '16px',
                        border: 'none',
                        backgroundColor: 'transparent',
                        cursor: 'pointer',
                        mt: -5,
                        ml: 10,
                    },
                    overlay: {
                        backgroundColor: 'rgba(144, 137, 137, 0.65)',
                    },
                    spotlight: {
                        backgroundColor: 'transparent',
                        borderRadius: '12px',
                        border: '3px solid #1976d2',
                        boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.65), 0 0 30px rgba(25, 118, 210, 0.5)',
                    },
                    beacon: {
                        backgroundColor: '#1976d2',
                        borderRadius: '50%',
                        border: '3px solid #ffffff',
                        boxShadow: '0 0 0 6px rgba(25, 118, 210, 0.3), 0 4px 16px rgba(25, 118, 210, 0.4)',
                        animation: 'pulse 2s infinite',
                    },
                    beaconInner: {
                        backgroundColor: '#1976d2',
                    },
                    beaconOuter: {
                        backgroundColor: 'rgba(25, 118, 210, 0.4)',
                        border: '2px solid #1976d2',
                    },
                    tooltipFooter: {
                        padding: '16px 24px',
                        borderTop: '1px solid #e0e0e0',
                        marginTop: '8px',
                    },
                }}
            />
            {children}
        </GuidedTourContext.Provider>
    );
};
